module.exports = "/images/PuertoRico.png?2dcaaebf3145520e49d535e332d286b7";